/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {editRequestIsPendingForTimecard} from '../api'

export const useMutationEditRequestIsPendingForTimecard = createReactQueryMutationHook('editRequestIsPendingForTimecard', editRequestIsPendingForTimecard)
